document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.lp-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
        if (btn.classList.contains('lp-btn-try-dynamic')) return;

        e.preventDefault();

        let target;

        if (btn.classList.contains('lp-btn-five')) {
            target = document.querySelector('#try-dynamic-buy-box');
        } else {
            target = document.querySelector('.lp-five');
        }

        if (target) {
            target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            });
        }
        });
    });
});